import { css } from '@bts-web/utils-style-engine';
import { FC } from 'react';
import { SkeletonElement } from '../../common/components/loading/SkeletonElement/SkeletonElement';

export const OrderSummarySkeleton: FC = () => {
  return (
    <div
      data-testid="order-summary-skeleton"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: 'screen_background.primary',
      })}
    >
      {/* Header */}
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 'medium',
          py: 'medium',
          borderBottomWidth: '1px',
          borderColor: 'neutrals.divider',
        })}
      >
        <SkeletonElement width="24px" height="24px" borderRadius="50%" />
        <SkeletonElement width="80px" height="20px" borderRadius="6px" />
        <SkeletonElement width="24px" height="24px" borderRadius="50%" />
      </div>

      {/* Asset and Target Price */}
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 'medium',
          py: 'medium',
          borderBottomWidth: '1px',
          borderColor: 'neutrals.divider',
        })}
      >
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: 'small',
          })}
        >
          <SkeletonElement width="24px" height="24px" borderRadius="50%" />
          <SkeletonElement width="40px" height="20px" borderRadius="6px" />
        </div>
        <SkeletonElement width="180px" height="18px" borderRadius="6px" />
      </div>

      {/* Main Content */}
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'large',
          px: 'medium',
          pt: 'large',
          pb: 'medium',
          flex: 1,
        })}
      >
        {/* Amount */}
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="200px" height="48px" borderRadius="6px" />
          <SkeletonElement width="150px" height="18px" borderRadius="6px" />
        </div>

        {/* Show limit order terms */}
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 'small',
            borderBottomWidth: '1px',
            borderColor: 'neutrals.divider',
          })}
        >
          <SkeletonElement width="160px" height="18px" borderRadius="6px" />
          <SkeletonElement width="24px" height="24px" borderRadius="6px" />
        </div>

        {/* Order is active for */}
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
        >
          <SkeletonElement width="120px" height="18px" borderRadius="6px" />
          <SkeletonElement width="80px" height="18px" borderRadius="6px" />
        </div>
      </div>

      {/* Footer */}
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'medium',
          px: 'medium',
          pb: 'large',
          pt: 'medium',
          borderTopWidth: '1px',
          borderColor: 'neutrals.divider',
        })}
      >
        {/* Total */}
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
        >
          <SkeletonElement width="60px" height="20px" borderRadius="6px" />
          <SkeletonElement width="140px" height="20px" borderRadius="6px" />
        </div>

        {/* CTA Button */}
        <SkeletonElement width="100%" height="56px" borderRadius="28px" />
      </div>
    </div>
  );
};
